/* @ngInject */

export default (helperService, OtherAdviser) => {
  /**
   * Get all other advisers types.
   *
   * @returns {Array}
   */
  const getAllOtherAdviserTypes = () => OtherAdviser.getAvailableOtherAdviserTypes();

  /**
   * Get available other advisers types.
   *
   * @param {Object} workflow
   *
   * @returns {Array}
   */
  const getAvailableOtherAdviserTypes = ({ workflow }) => {
    if (workflow) {
      let otherAdviserTypes = OtherAdviser.getAvailableOtherAdviserTypes();
      if (!workflow.isAssetFinance()) {
        otherAdviserTypes = _.reject(
          otherAdviserTypes,
          (_, index) => index === 4 || index === 5
        );
      } else {
        otherAdviserTypes = _.reject(otherAdviserTypes, (_, index) => index === 2);
      }
      return otherAdviserTypes;
    }
    return OtherAdviser.getAvailableOtherAdviserTypes();
  };

  /**
   * Add otherAdviser to otherAdvisers array.
   *
   * @param {Array} otherAdvisers
   * @param {Object} otherAdviserType
   *
   * @returns {Number}
   */
  const otherAdviserAdd = (otherAdvisers, otherAdviserType) => {
    otherAdvisers.push(OtherAdviser.blank(otherAdviserType));
    return otherAdvisers;
  };

  /**
   * Remove otherAdviser from otherAdvisers array.
   *
   * @param {Array} otherAdvisers
   * @param {Number} index
   *
   * @returns {Array}
   */
  const otherAdviserDelete = (otherAdvisers, index) =>
    helperService.removeItemFromArray(otherAdvisers, index);

  return {
    getAllOtherAdviserTypes,
    getAvailableOtherAdviserTypes,
    otherAdviserAdd,
    otherAdviserDelete
  };
};
